const formular = document.querySelector('.ce_rsce_formular');

if (formular){
    formular.addEventListener('click', function(){
        if (location.href.includes('#') != true){
            location.href = location.href + '#formular';
        }
    })
}